/**
 * Page for profile management
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { uiState } from 'react-redux-ui-state';

import ORContentHeader from 'components/ORContentHeader/ORContentHeader';
import ORContentArea from 'components/ORContentArea/ORContentArea';
import PersonalInfoTab from './PersonalInfoTab/PersonalInfoTab';
import BillingTab from './BillingTab/BillingTab';
import SecurityTab from './SecurityTab/SecurityTab';
// import WelcomeCard from './WelcomeCard/WelcomeCard';

const propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    leftCol: PropTypes.string.isRequired,
    rightCol: PropTypes.string.isRequired,
    card: PropTypes.string.isRequired,
  }).isRequired,
  setUiState: PropTypes.func.isRequired,
  profileTabSelectionValue: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  MFAEnabled: PropTypes.bool.isRequired,
  flags: PropTypes.shape({}), // eslint-disable-line react/require-default-props
};

export function UnstyledProfilePage({
  classes,
  setUiState,
  profileTabSelectionValue,
  userId,
  MFAEnabled,
  flags,
}) {
  const changeTabSelection = (event, value) => {
    setUiState({
      profileTabSelectionValue: value,
    });
  };

  let currentDisplayedTab = null;

  if (profileTabSelectionValue === 'personal') {
    currentDisplayedTab = <PersonalInfoTab />;
  } else if (profileTabSelectionValue === 'security') {
    currentDisplayedTab = <SecurityTab MFAEnabled={MFAEnabled} userId={userId} />;
  } else if (profileTabSelectionValue === 'billing') {
    currentDisplayedTab = <BillingTab />;
  }

  return (
    <React.Fragment>
      <ORContentHeader hasDivider>Profile Management</ORContentHeader>
      <ORContentArea>
        <Tabs
          value={profileTabSelectionValue}
          onChange={changeTabSelection}
          variant="scrollable"
          indicatorColor="primary"
          scrollButtons="auto"
          className={classes.profileTabsBar}
          classes={{ indicator: classes.tabsIndicator, flexContainer: classes.tabsFlexContainer }}
        >
          <Tab value="personal" label="Personal Info" />
          {
            flags && flags['security-tab'] && <Tab value="security" label="Security" /> // eslint-disable-line react/prop-types
          }
          <Tab value="billing" label="Billing" />
        </Tabs>
        <Divider className={classes.tabDivider} />
        {currentDisplayedTab}
        {/* Leaving this here for now because Ange says she wants it out now
        but back later after some changes
        <WelcomeCard className={classes.card} />
      */}
      </ORContentArea>
    </React.Fragment>
  );
}

UnstyledProfilePage.propTypes = propTypes;

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
  },
  leftCol: {
    flex: 1,
  },
  rightCol: {
    flex: 1,
  },
  card: {
    marginTop: theme.spacing(2),
  },
  [theme.breakpoints.down('md')]: {
    root: {
      flexDirection: 'column',
    },
    leftCol: {
      flex: 1,
    },
  },
  [theme.breakpoints.only('sm')]: {
    leftCol: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    rightCol: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
  },
  [theme.breakpoints.only('md')]: {
    leftCol: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
    rightCol: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
  },
  [theme.breakpoints.up('md')]: {
    leftCol: {
      marginLeft: theme.spacing(2),
    },
    rightCol: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
  },
  profileTabsBar: {
    width: '100%',
    color: theme.customColors.black,
    backgroundColor: theme.customColors.coolBlue,
  },
  tabDivider: {
    position: 'relative',
    top: '-2px',
    height: '2px',
    marginBottom: theme.spacing(2),
  },
  tabsIndicator: {
    zIndex: 1,
  },
  tabsFlexContainer: {
    justifyContent: 'center',
  },
});

export const uiConfig = {
  name: 'profileTabSelectionValue',
  state: () => ({
    profileTabSelectionValue: 'personal',
  }),
};

export default uiState(uiConfig)(withStyles(styles)(UnstyledProfilePage));
